var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTranslate } from 'ra-core';
import classnames from 'classnames';
import get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
export const AccessField = (_a) => {
    var { basePath, cellClassName, // Use by react admin, should not propagate
    headerClassName, // Use by react admin, should not propagate
    record, source, translationKey } = _a, props = __rest(_a, ["basePath", "cellClassName", "headerClassName", "record", "source", "translationKey"]);
    const value = get(record, source);
    const enabled = value === 'ENABLED';
    const color = enabled ? 'primary' : 'default';
    const classes = useStyles();
    const translate = useTranslate();
    return (React.createElement(Chip, Object.assign({ color: color, disabled: !enabled, className: classnames(classes.root, { [classes.enabled]: enabled }), label: value
            ? translate(`${translationKey}.${value.toLowerCase()}`)
            : '' }, props)));
};
const useStyles = makeStyles(theme => ({
    root: { borderRadius: theme.spacing(0.5) },
    enabled: {
        backgroundColor: theme.palette.success.main,
    },
}), {
    name: 'Layer7AccessField',
});
//# sourceMappingURL=AccessField.js.map